export default "__VITE_ASSET__D$iJEOCN__"